export const environment = {
  production: true,
  domain: 'telesite.telepost.me',
  hmr: false,
  apiPath: '/api'
};
